import { Component, OnInit, Input, Output, EventEmitter, ChangeDetectionStrategy, AfterViewInit, ChangeDetectorRef } from '@angular/core';
import { NotificationsService } from 'angular2-notifications';
import { InterpretationService } from '../../interpretation.service';
import { FileReaderEvent } from '../../../../shared/models/FileReader';
import { AddComponentPhotoModel, AddWSREFrameComponentPhotoModel, SystemInspectionImagesModel } from '../../models/interpretation.model';
import { PopupEndPoint } from '../../../inspection/models/create-inspection.model';
import { TemperatureInspectionService } from '../../../Temperature/temperature-inspection.service';
import { ThermographyInspectionService } from '../../../../../app/modules/Thermography/thermography-inspection.service';
import { WsreService } from '../../.../../../../../app/modules/wsre/wsre.service';
import { ImageVM, SystemComponentViewModel } from '../../../inventory/inventory-models';
import { InventoryService } from '../../../inventory/inventory-service.service';
import { MatDialog } from '@angular/material/dialog';
import { heicTo } from 'heic-to';

@Component({
  selector: 'upload-photo',
  templateUrl: './upload-photo.component.html',
  styleUrls: ['./upload-photo.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})


export class UploadPhotoComponent implements OnInit, AfterViewInit {
  @Input() inspectionDetailId: number;
  @Input() componentModel: any;
  @Input() inspectionId: number;
   @Input() systemId: number;
  @Output() onPhotoUpload: EventEmitter<any> = new EventEmitter();
   @Output() SystemPhotoUpload: EventEmitter<any> = new EventEmitter();
  photo = '';
  photoLoading = false;
  @Input() isCreatingNewInspection: boolean;
  @Input() isTempInspection: boolean;
  @Input() isTempInspectionDetail: boolean;
  @Input() isThermoInspectionDetail: boolean;
  @Input() isWSREFrameObs: boolean;
  @Input() WSREMeasurementPointId: number;
  @Input() Side: number;
  @Input() IsFinalMeasurementImg: boolean;
  @Input() comingFrom: PopupEndPoint;
  @Input() ObservationListId: number;
  @Input() ObsphotoId: number=0;
  @Input() referenceTableId: number = 0;
  @Input() imageUrl:boolean = false;
  @Input() isAllImagesUpload:boolean = false;
   @Input() isInspectionAddEdit:boolean = false;

  Image: ImageVM = new ImageVM;
  constructor(private _interp: InterpretationService,
    private _notify: NotificationsService,
    private _cdr: ChangeDetectorRef, private _temperatureService: TemperatureInspectionService,
    private _thermogarphyService:ThermographyInspectionService,
    private _wsreService: WsreService,
    private _dialog: MatDialog,
    private inventoryService: InventoryService,
  ) { }

  ngOnInit() {
    console.log(this.systemId)
  }
  ngAfterViewInit() {
    this._cdr.detach();
  }

  sucessfullyUploaded(title: string, message: string, image: string, imagePath?:string) {
    this._notify.success(title, message);
    console.log("this.onPhotoUpload.emit({image: image, imagePath: imagePath})",image, imagePath);
    if(imagePath != null)
      this.onPhotoUpload.emit({image: image, imagePath: imagePath});
    else 
      this.onPhotoUpload.emit(image);
    this.photoLoading = false;
    this._cdr.detectChanges();
  }

  errorMessage(title: string, message: string, err) {
    console.error(err);
    this.photoLoading = false;
    this._notify.error('Error', 'Unable to update the photo. Please contact TrackTreads support. ');
    this._cdr.detectChanges();
  }

  uploadPhoto(newPhoto: string) {

    this.photoLoading = true;
    this._cdr.detectChanges();
    const photo = new AddComponentPhotoModel();
    photo.InspectionId = this.inspectionId;
    photo.InspectionDetailId = this.inspectionDetailId;
    photo.NewPhoto = newPhoto;
    photo.ComponentModel = this.componentModel;

    console.log("ObsphotoId",this.ObsphotoId)
    if (this.comingFrom) {
      switch (this.comingFrom) {
        case PopupEndPoint.ObservationListInterpretation:
          this._interp.UpdateInspectionObservationListPhoto(this.ObservationListId, newPhoto,this.ObsphotoId).subscribe(p => {
            this.sucessfullyUploaded('Uploaded', 'Additional Observation Photo', p.m_Item2);
          });
          break;
        case PopupEndPoint.ObservationListCreateInspection:
          if(this.imageUrl){
            this._interp.addInspectionComponentPhoto(photo).subscribe(p => {
          if (p.ImagePath != '' || p.ImagePath != null) {
            this.sucessfullyUploaded('Uploaded', 'Image Uploaded Successfully', p.ImageUrl, p.ImagePath);
          } else {
            this.errorMessage('Failed', 'Unable to upload the photo. Please contact TrackTreads support. ','');
          }
          
        });
          }else {
            this._interp.UpdateObservationListDraftPhoto(this.ObservationListId, newPhoto,this.ObsphotoId).subscribe(p => {
            this.sucessfullyUploaded('Uploaded', 'Additional Observation Photo', p.m_Item1);
          });
          }
          break;
        case PopupEndPoint.InventoryComponent:
          this.updateInventoryComponentImage(photo);
          //this._interp.UpdateObservationListDraftPhoto(this.ObservationListId, newPhoto, this.ObsphotoId).subscribe(p => {
          //  this.sucessfullyUploaded('Uploaded', 'Additional Observation Photo', p.m_Item1);
          //});
          break;
        case PopupEndPoint.AddNewInspectionComponent:

        break;
         case PopupEndPoint.SystemInspectionImages:
          const photo1 = new SystemInspectionImagesModel();
          photo1.InspectionId = this.inspectionId;
          photo1.SystemId = this.inspectionDetailId;
          photo1.ImagePath = newPhoto;
          photo1.IsInspectionAddOrEdit = this.isInspectionAddEdit?true:false;

         this._interp.AddSystemInspectionImages(photo1).subscribe(p => {
          if(p)
            {
              if(!this.isInspectionAddEdit){
                  this.SystemPhotoUpload.emit({imagePath: p, SystemId: this.inspectionDetailId});
              }else{
                 this.SystemPhotoUpload.emit({imagePath: p, SystemId: this.inspectionDetailId});
              }
          
            this._notify.success('Uploaded', 'Image Uploaded Successfully');
          }
          this.photoLoading = false;
          this._cdr.detectChanges();
          });
        break;
      }
    } else {
      if (!this.isCreatingNewInspection && !this.isTempInspection && !this.isTempInspectionDetail && !this.isThermoInspectionDetail && !this.isWSREFrameObs) {
        this._interp.addComponentPhoto(photo).subscribe(p => {
          if (p.m_Item1 > 0) {
            this.sucessfullyUploaded('Uploaded', p.m_Item2, p.m_Item1);
            //this.photoLoading = false;
          } else {
            this._notify.error('Failed', 'Unable to upload the photo. Please contact TrackTreads support. ');
            console.error(p.m_Item2);
            //this.photoLoading = false;
            this._cdr.detectChanges();
          }
          this.photoLoading = false;
        }, err => {
          this.errorMessage('Failed', 'Unable to upload the photo. Please contact TrackTreads support. ', err);

        });
      } else if (this.isCreatingNewInspection && !this.isTempInspection && !this.isTempInspectionDetail && !this.isThermoInspectionDetail && !this.isWSREFrameObs) {
        // this._interp.addInspectionComponentPhotoDraft(photo).subscribe(p => {
        this._interp.addInspectionComponentPhoto(photo).subscribe(p => {
          if (p.ImagePath != '' || p.ImagePath != null) {
            this.sucessfullyUploaded('Uploaded', 'Image Uploaded Successfully', p.ImageUrl, p.ImagePath);
          } else {
            this.errorMessage('Failed', 'Unable to upload the photo. Please contact TrackTreads support. ','');

          }
        });
      }
      else if (this.isTempInspection && !this.isTempInspectionDetail && !this.isThermoInspectionDetail && !this.isWSREFrameObs) {
        console.log("Temp...")
        this._temperatureService.addTemperatureInspectionPhoto(photo).subscribe(p => {
          if (p.m_Item1 > 0) {
            this.sucessfullyUploaded('Uploaded', p.m_Item2, p.m_Item1);
          } else {
            this.errorMessage('Failed', 'Unable to upload the photo. Please contact TrackTreads support. ', p.m_Item2);

          }
        });
      }

      else if (!this.isTempInspection && this.isTempInspectionDetail && !this.isThermoInspectionDetail && !this.isWSREFrameObs) {
        console.log("Temp details...")
        this._temperatureService.addTemperatureInspectionDetailPhoto(photo).subscribe(p => {
          if (p.m_Item1 > 0) {
            this.sucessfullyUploaded('Uploaded', p.m_Item2, p.m_Item1);
          } else {
            this.errorMessage('Failed', 'Unable to upload the photo. Please contact TrackTreads support. ', p.m_Item2);

          }
        });
      }

      else if (!this.isTempInspection && !this.isTempInspectionDetail && this.isThermoInspectionDetail && !this.isWSREFrameObs) {
        console.log("Thermogarphy details..._____")
        this._thermogarphyService.addThermogarphyInspectionDetailPhoto(photo).subscribe(p => {
          if (p.m_Item1 > 0) {
            this.sucessfullyUploaded('Uploaded', p.m_Item2, p.m_Item1);
          } else {
            this.errorMessage('Failed', 'Unable to upload the photo. Please contact TrackTreads support. ', p.m_Item2);

          }
        });
      }
      else if (!this.isTempInspection && !this.isTempInspectionDetail && !this.isThermoInspectionDetail && this.isWSREFrameObs) {
        console.log("WSREFrame obs details..._____")

        const photo = new AddWSREFrameComponentPhotoModel();
        photo.WSREID = this.inspectionId;
        photo.WSREMeasurementPointId = this.WSREMeasurementPointId;
        photo.CompartMeasurementPointId = this.inspectionDetailId;
        photo.NewPhoto = newPhoto;
        photo.side=this.Side;
        photo.IsFinalMeasurementImg = this.IsFinalMeasurementImg;
        this._wsreService.AddWSREFrameComponentImages(photo).subscribe(p => {
          if (p.m_Item1 > 0) {
            this.sucessfullyUploaded('Uploaded', p.m_Item2, p.m_Item1);
          } else {
            this.errorMessage('Failed', 'Unable to upload the photo. Please contact TrackTreads support. ', p.m_Item2);

          }
        });
      }
    }



  }
  private compressImage(src) {
    return new Promise((res, rej) => {
      const img = new Image();
      img.src = src;
      img.onload = () => {
        const elem = document.createElement('canvas');
        let width, height;
        width = img.width;
        height = img.height;
        console.log('width', width)
        console.log('height', height)
        var ratio = height / width; //cal aspect ratio
        let imageWidth = 800;//643
        var new_height = imageWidth * ratio; //calculate new height
        elem.width = imageWidth;
        elem.height = new_height;
        const ctx = elem.getContext('2d');
        ctx.drawImage(img, 0, 0, imageWidth, new_height);
        const data = ctx.canvas.toDataURL();
        res(data);
      }
      img.onerror = error => rej(error);
    })
  }

//   onSelectPhoto(event: any) {
//     if (event.target.files && event.target.files[0]) {
//       this.photoLoading = true;
//       this._cdr.detectChanges();
//       let file = event.target.files[0];
//       console.log(file.type);
//       console.log(file.size);
//       //const isHeic = file.type === "image/heic" || file.name.toLowerCase().endsWith(".heic");
//       const extension = file.name.split('.').pop()?.toLowerCase();
//       const isHeic = extension === 'heic' || extension === 'heif' || file.type.toLowerCase().includes('heic') || file.type.toLowerCase().includes('heif');
//       console.log(isHeic);
//       const processFile = (f: File) => {
//         const reader = new FileReader();
//         reader.onload = (e: any) => {
//           const imageUrl = e.target.result;
//           this.compressImage(imageUrl).then((res: string) => {
//             if (res) {
//               this.uploadPhoto(res.split(',')[1]);
//             }
//           });
//         };
//         reader.readAsDataURL(f);
//       };
//       // if (isHeic) {
//       //   heic2any({
//       //     blob: file,
//       //     toType: "image/jpeg",
//       //     quality: 0.8
//       //   })
//       //   .then((result: any) => {
//       //     const convertedBlob = Array.isArray(result) ? result[0] : result;
//       //     const convertedFile = new File([convertedBlob], "converted.jpg", {
//       //       type: "image/jpeg"
//       //     });
//       //     processFile(convertedFile);
//       //   })
//       //   .catch((err: any) => {
//       //     this.photoLoading = false;
//       //     console.error("HEIC conversion failed", err);
//       //     this._notify.error('Error', 'Unable to update the photo. Please contact TrackTreads support. ');
//       //   });
//       // } else {
//       //   processFile(file);
//       // }
//       // event.target.value = null;

//       if (isHeic) {

//     console.log("HEIC detected");

//     heic2any({
//         blob: file,
//         toType: "image/jpeg",
//         quality: 0.8
//     })
//     .then((result: Blob | Blob[]) => {

//         console.log("Conversion succeeded");
//         console.log(result);

//         const convertedBlob = Array.isArray(result)
//             ? result[0]
//             : result;

//         console.log(convertedBlob);

//         const convertedFile = new File(
//             [convertedBlob],
//             "converted.jpg",
//             {
//                 type: "image/jpeg"
//             }
//         );

//         processFile(convertedFile);

//     })
//     .catch((err: any) => {

//         console.error("HEIC conversion failed");
//         console.error(err);
//         console.error(err.message);
//         console.error(err.code);

//         alert(err.message);

//     });

// }
//     }
//   }

  async onSelectPhoto(event: any) {
    if (!(event.target.files && event.target.files[0])) {
        return;
    }
    this.photoLoading = true;
    this._cdr.detectChanges();
    const file = event.target.files[0];
    const extension = file.name.split('.').pop()?.toLowerCase();
    const isHeic = extension === 'heic' || extension === 'heif';
      const processFile = (f: File) => {
          const reader = new FileReader();
          reader.onload = (e: any) => {
            this.compressImage(e.target.result).then((res: string) => {
                if (res) {
                    this.uploadPhoto(res.split(',')[1]);
                }
            });
          };
          reader.readAsDataURL(f);
      };
      try {
        if (isHeic) {
          const blob = await heicTo({
              blob: file,
              type: "image/jpeg",
              quality: 0.8
          });
          processFile(new File(
              [blob],
              "converted.jpg",
              {
                  type: "image/jpeg"
              }
          ));
        } else {
            processFile(file);
          }
      }
      catch (err) {
          this.photoLoading = false;
          console.error(err);
          this._notify.error(
              "Unsupported HEIC",
              "Unable to convert this HEIC image."
          );
      }
    event.target.value = null;
  }
  updateInventoryComponentImage(Photo: any) {
    this.Image.Image = Photo.NewPhoto;
    this.Image.ReferenceTableId = this.referenceTableId;
    this.Image.ComponentModel = this.componentModel;

    this.inventoryService.updateSystemInInventoryImage(this.Image).subscribe(p => {
      if (p.m_Item1) {
        this.sucessfullyUploaded('Uploaded', p.m_Item2, p.m_Item1);
      } else {
        this.errorMessage('Failed', 'Unable to upload the photo. Please contact TrackTreads support. ', p.m_Item2);
      }
    });
    
  }

}

